import React from "react";
import logo from "../images/logo.png";
import "./Menu.css";
import { Container, Image, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import SessionMenuItemContainer from "../domains/session/SessionMenuItemContainer";
import SecuredContainer from "../domains/session/SecuredContainer";

const Menu = () => (
  <div className="Menu">
    <Container>
      <Navbar variant={"dark"} expand={"xl"}>
        <Navbar.Brand>
          <NavLink to="/">
            <Image src={logo} responsive="true" />
          </NavLink>
        </Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse className="justify-content-end" style={{  textAlign: "right"}}>
          <Nav>
            <Nav.Item>
              <Nav.Link as={NavLink} to="/info#omoss" end>Om oss</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={NavLink} to="/info#kontakt" end>Kontakt</Nav.Link>
            </Nav.Item>
          </Nav>
          <SecuredContainer allowedRoles={["ADMIN"]}>
            <Nav>
              <NavDropdown title="Rapporter" id="rapporter-dropdown">
                <NavDropdown.Item as={NavLink} to="/rapporter/fakturaunderlag">Fakturaunderlag</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/rapporter/fakturaunderlag-meny">Fakturaunderlag Test</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/rapporter/annat">Annat</NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </SecuredContainer>
          <SecuredContainer allowedRoles={["ADMIN"]}>
            <Nav>
              <Nav.Item>
                <Nav.Link as={NavLink} to="/logg" eventKey="Händelselogg">Händelselogg</Nav.Link>
              </Nav.Item>
            </Nav>
          </SecuredContainer>
          <SecuredContainer allowedRoles={["ADMIN", "OPTICIAN", "CARE_UNIT", "CARE_UNIT_ADMIN", "OPTICIAN_ADMIN"]}>
            <Nav>
              <NavDropdown title="Remiss" id="remiss-dropdown">
                <SecuredContainer allowedRoles={["ADMIN", "OPTICIAN", "OPTICIAN_ADMIN"]}>
                  <NavDropdown.Item as={NavLink} to="/remiss/skapa">Skapa</NavDropdown.Item>
                </SecuredContainer>
                <NavDropdown.Item as={NavLink} to="/remiss/hitta">Hitta</NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </SecuredContainer>
          <SecuredContainer allowedRoles={["ADMIN", "CARE_UNIT", "CARE_UNIT_ADMIN"]}>
            <Nav>
              <Nav.Item>
                <Nav.Link as={NavLink} to="/optiker" eventKey="Optiker">Optiker</Nav.Link>
              </Nav.Item>
            </Nav>
          </SecuredContainer>
          <SecuredContainer allowedRoles={["ADMIN"]}>
            <Nav>
              <Nav.Item>
                <Nav.Link as={NavLink} to="/vardenheter" eventKey="Vårdenhet">Vårdenheter</Nav.Link>
              </Nav.Item>
            </Nav>
          </SecuredContainer>
          <SecuredContainer allowedRoles={["ADMIN", "CARE_UNIT_ADMIN", "OPTICIAN_ADMIN"]}>
            <Nav>
              <Nav.Item>
                <Nav.Link as={NavLink} to="/anvandare" end eventKey="Användare">Användare</Nav.Link>
              </Nav.Item>
            </Nav>
          </SecuredContainer>
          <Nav>
            <SessionMenuItemContainer />
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </Container>
  </div>
);

export default Menu;
